<template>
  <div
    class="divSolvePlan"
    v-lazy:background-image="{
      src: bg,
    }"
  >
  <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    bg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      img: "",
    };
  },
  methods: {},
};
</script>

<style lang="scss">
@import "./../scss/solvePlanWidge.scss";
</style>
